<template>
	<div class="page-container">
		<v-app light>
			<v-toolbar app clipped-left fixed>
				<v-icon @click="showNavigation = !showNavigation"> menu </v-icon>
				<img
					@click="canManuallyTransmit ? fertigerWechseln() : 0"
					src="../assets/blexon_logo_portal.png"
					style="height: 50px; padding-left: 20px; cursor: pointer"
				/>
				<v-icon
					:color="adapterStateColor"
					v-if="getFertiger() != undefined"
					style="padding-left: 10px"
					large
					:title="lastPollFormatted"
				>
					offline_bolt
				</v-icon>
				<img
					v-if="getFertiger() != undefined"
					style="height: 40px; padding-left: 20px"
					onerror="this.style.display = 'none'"
					:src="getFertigerLogo()"
				/>

				<v-spacer></v-spacer>

				<v-menu offset-y>
					<v-btn style="text-transform: none !important" slot="activator">
						<v-icon> face </v-icon>
						{{ username }}
					</v-btn>
					<v-list>
						<v-list-tile @click="logout()">
							<v-list-tile-title>Abmelden</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</v-toolbar>
			<v-navigation-drawer app clipped v-if="fertigerName != ''" v-model="showNavigation">
				<v-list>
					<v-list-tile v-if="getFertiger().canEditOffers" @click="navigateTo('offers')">
						<v-list-tile-action>
							<v-icon large color="accent">euro</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>Angebote</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile @click="navigateTo('order')">
						<v-list-tile-action>
							<v-icon large color="accent">event_note</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>Aufträge</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile @click="navigateTo('production')">
						<v-list-tile-action>
							<v-icon large color="accent">3d_rotation</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>CAD Modell</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile
						v-show="
							!getFertiger().isExternalPowderCoater && getFertiger().canEditComplains
						"
						@click="navigateTo('tickets')"
					>
						<v-list-tile-action>
							<v-badge color="red" overlap>
								<template v-slot:badge>
									<span slot="badge" small v-if="beanstandungsCount > 0">{{
										beanstandungsCount
									}}</span>
								</template>
								<v-icon large color="accent">flash_on</v-icon>
							</v-badge>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>Beanstandungen</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile
						v-show="
							!getFertiger().isExternalPowderCoater &&
							(getFertiger().canEditProgrammingData || getFertiger().canEditComplains)
						"
						@click="navigateTo('report')"
					>
						<v-list-tile-action>
							<v-icon large color="accent">trending_up</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>Statistik</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile
						v-show="!getFertiger().isExternalPowderCoater"
						@click="navigateTo('leergut')"
					>
						<v-list-tile-action>
							<v-icon large color="accent">pallet</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>Leergut</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile @click="navigateTo('orderTape')">
						<v-list-tile-action>
							<v-icon large color="accent">markunread_mailbox</v-icon>
						</v-list-tile-action>
						<v-list-tile-title> Klebeband bestellen </v-list-tile-title>
					</v-list-tile>
					<v-list-tile @click="navigateTo('planning')">
						<v-list-tile-action>
							<v-icon large color="accent">calendar_month</v-icon>
						</v-list-tile-action>
						<v-list-tile-title> Werkskalender </v-list-tile-title>
					</v-list-tile>
					<v-list-group
						v-if="getFertiger().canEditProgrammingData"
						no-action
						:value="false"
					>
						<template v-slot:activator>
							<v-list-tile>
								<v-list-tile-action>
									<v-icon large color="accent">settings</v-icon>
								</v-list-tile-action>
								<v-list-tile-title>Einstellungen</v-list-tile-title>
							</v-list-tile>
						</template>

						<v-list-tile @click="navigateTo('material')">
							<v-list-tile-title> Material </v-list-tile-title>
							<v-list-tile-action>
								<v-icon>line_weight</v-icon>
							</v-list-tile-action>
						</v-list-tile>
						<v-list-tile @click="navigateTo('tools')">
							<v-list-tile-title> Werkzeuge </v-list-tile-title>
							<v-list-tile-action>
								<v-icon>build</v-icon>
							</v-list-tile-action>
						</v-list-tile>
						<v-list-tile @click="navigateTo('pressJoins')">
							<v-list-tile-title> Einpressungen </v-list-tile-title>
							<v-list-tile-action>
								<v-icon> download </v-icon>
							</v-list-tile-action>
						</v-list-tile>
						<v-list-tile
							v-if="!getFertiger().useWorkplacesInsteadWorkplans"
							@click="navigateTo('workplans')"
						>
							<v-list-tile-title> Arbeitspläne </v-list-tile-title>
							<v-list-tile-action>
								<v-icon>rule</v-icon>
							</v-list-tile-action>
						</v-list-tile>
						<v-list-tile v-else @click="navigateTo('workplaces')">
							<v-list-tile-title> Arbeitsplätze </v-list-tile-title>
							<v-list-tile-action>
								<v-icon>table_restaurant</v-icon>
							</v-list-tile-action>
						</v-list-tile>
						<v-list-tile @click="navigateTo('editFertiger')">
							<v-list-tile-title> Betriebsdaten </v-list-tile-title>
							<v-list-tile-action>
								<v-icon>corporate_fare</v-icon>
							</v-list-tile-action>
						</v-list-tile>
					</v-list-group>
					<v-list-tile v-show="getFertiger().canReadLogs" @click="navigateTo('log')">
						<v-list-tile-action>
							<v-icon large color="accent">bug_report</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>Meldungen</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>
			</v-navigation-drawer>
			<v-content>
				<router-view></router-view>
			</v-content>
		</v-app>
	</div>
</template>

<script>
import { routes } from "../router/routes";
import router from "../router/index";
import { namespace, action } from "../store/types";
import store from "../store";
import moment from "moment";

export default {
	data() {
		return {
			routes,
			showNavigation: false,
		};
	},
	mounted() {
		moment.locale("de");
		if (this.$vuetify.breakpoint.name === "lg" || this.$vuetify.breakpoint.name === "xl") {
			this.showNavigation = true;
		}
	},
	computed: {
		lastPollFormatted() {
			return moment(this.lastPoll).format("[Letztes Signal am:] D. MMMM YYYY - HH:mm [Uhr]");
		},
		adapterStateColor() {
			if (moment().subtract(30, "minutes").isBefore(this.lastPoll)) {
				return "success";
			} else {
				return "error";
			}
		},
		username() {
			console.log("Logged in as: " + this.$store.state.oidc.user.profile.email);
			return this.$store.state.oidc.user.profile.email.toLowerCase();
		},
		fertigerName() {
			var fertiger = this.getFertiger();
			if (fertiger !== undefined) {
				return fertiger.name;
			}
			return "";
		},
		lastPoll() {
			var fertiger = this.getFertiger();
			if (fertiger !== undefined) {
				return fertiger.lastPoll;
			}
			return "";
		},
		beanstandungsCount() {
			return this.$store.state.beanstandungsCount;
		},
		canManuallyTransmit() {
			return this.$store.getters.currentFertiger(this.$route.params.fertigerId)
				.canManuallyTransmit;
		},
	},
	methods: {
		/**
		 * Returns the currently selected Fertiger. This
		 * information is extracted from the URL
		 */
		getFertiger() {
			var fertigerId = this.$route.params.fertigerId;
			return this.$store.state.fertiger.find((f) => f.id == fertigerId);
		},

		getFertigerLogo() {
			return `${process.env.VUE_APP_SERVER_URL}api/fertiger/getlogo?fertigerId=${this.getFertiger().id}`;
		},

		fertigerWechseln() {
			router.push({ name: "fertiger" });
		},
		navigateTo(route) {
			var fertigerId = this.$route.params.fertigerId;
			router.push({ name: route, params: { fertigerId: fertigerId } });
		},
		logout() {
			console.log("Log out");
			store.dispatch(action.LOGOUT);
		},
	},
};
</script>

<style>
.page-container a:hover {
	text-decoration: none;
}
</style>
